import React, { useState } from "react";
import "./ClosureUpdate.css";

const ClosureUpdate = () => {
  const [language, setLanguage] = useState("en");

  const content = {
    en: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "Temporary Closure & Remodeling Update",

      paragraphs: [
        "After serving our community for 15 years, Hiro Japanese Buffet is currently temporarily closed due to a water leak that occurred during our remodeling project.",

        "During the remodeling process, our contractor opened part of the roof. Heavy rain followed, and a large amount of water entered through the roof and ceiling, causing serious damage inside the restaurant.",

        "For the safety of our guests and employees, we had no choice but to temporarily close the restaurant.",

        "This has been a very difficult time for our family, but we are actively working to address the damage and continue the remodeling process, with the hope of reopening as soon as possible.",

        "Thank you to every customer who has supported Hiro over the past 15 years. We are truly grateful for all of your support throughout this journey. ❤️ We sincerely hope that when we reopen, you will come back and continue supporting us.",
      ],

      highlight1: "This is not the end of Hiro.",
      highlight2: "We will be back. 🍣❤️",

      final:
        "Please continue following our accounts. We will keep you updated on the remodeling progress and share the latest news about our reopening.",

      english: "English",
      chinese: "中文",
      spanish: "Español",
    },

    zh: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "临时停业及装修进度通知",

      paragraphs: [
        "在为社区服务了 15 年之后，Hiro Japanese Buffet 目前因装修期间发生的漏水问题而暂时停业。",

        "在装修过程中，我们的承包商拆开了部分屋顶。随后遇到大雨，雨水从屋顶和天花板大量渗入，导致餐厅内部受到严重损坏。",

        "为了保障顾客和员工的安全，我们不得不暂时关闭餐厅。",

        "这段时间对我们一家人来说非常艰难，但我们正在积极处理损坏，并继续推进装修，希望能够尽快重新营业。",

        "感谢过去 15 年来一直支持 Hiro 的每一位顾客。真的非常感谢大家一路以来的支持。 ❤️ 我们也真心希望，在我们重新开业后，大家还愿意回来继续支持我们。",
      ],

      highlight1: "这不是 Hiro 的结束。",
      highlight2: "我们一定会回来。 🍣❤️",

      final:
        "请继续关注我们的账号，我们会及时发布装修进度和重新开业的最新消息。",

      english: "English",
      chinese: "中文",
      spanish: "Español",
    },

    es: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "Aviso de Cierre Temporal y Remodelación",

      paragraphs: [
        "Después de servir a nuestra comunidad durante 15 años, Hiro Japanese Buffet se encuentra temporalmente cerrado debido a una filtración de agua que ocurrió durante nuestro proyecto de remodelación.",

        "Durante el proceso de remodelación, nuestro contratista abrió una parte del techo. Poco después, hubo fuertes lluvias y una gran cantidad de agua entró por el techo y el cielo raso, causando daños graves dentro del restaurante.",

        "Por la seguridad de nuestros clientes y empleados, no tuvimos otra opción que cerrar temporalmente el restaurante.",

        "Este ha sido un momento muy difícil para nuestra familia, pero estamos trabajando activamente para reparar los daños y continuar con la remodelación, con la esperanza de poder reabrir lo antes posible.",

        "Gracias a cada uno de nuestros clientes que ha apoyado a Hiro durante los últimos 15 años. Estamos verdaderamente agradecidos por todo su apoyo a lo largo de este camino. ❤️ Esperamos sinceramente que, cuando volvamos a abrir, regresen y continúen apoyándonos.",
      ],

      highlight1: "Este no es el final de Hiro.",
      highlight2: "Volveremos. 🍣❤️",

      final:
        "Por favor, continúen siguiendo nuestras cuentas. Compartiremos actualizaciones sobre el progreso de la remodelación y las últimas noticias sobre nuestra reapertura.",

      english: "English",
      chinese: "中文",
      spanish: "Español",
    },
  };

  const text = content[language];

  return (
    <main className="closure-update-page">
      <div
        className="closure-update-container"
        lang={language === "zh" ? "zh" : language === "es" ? "es" : "en"}
      >
        <p className="closure-update-eyebrow">{text.eyebrow}</p>

        <div className="closure-update-language-switcher">
          <button
            className={language === "en" ? "active" : ""}
            onClick={() => setLanguage("en")}
          >
            {text.english}
          </button>

          <button
            className={language === "zh" ? "active" : ""}
            onClick={() => setLanguage("zh")}
          >
            {text.chinese}
          </button>

          <button
            className={language === "es" ? "active" : ""}
            onClick={() => setLanguage("es")}
          >
            {text.spanish}
          </button>
        </div>

        <h1>{text.title}</h1>

        <div className="closure-update-divider" />

        <div className="closure-update-body">
          {text.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}

          <div className="closure-update-highlight">
            <strong>{text.highlight1}</strong>
            <br />
            <strong>{text.highlight2}</strong>
          </div>

          <p>{text.final}</p>
        </div>
      </div>
    </main>
  );
};

export default ClosureUpdate;
